import { makeStyles } from '@material-ui/core/styles'
import { color, focusRing, fontFamily, shadowLg, smUp } from './tokens'

// Mirrors the mock's shadcn AlertDialog + Button (lovable/screenhub-cms/src/components/ui).
export const useDialogStyles = makeStyles({
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)'
  },
  paper: {
    // AlertDialogContent: grid w-full max-w-xl gap-4 border bg-background p-6 shadow-lg sm:rounded-lg
    display: 'grid',
    gap: 16,
    width: '100%',
    maxWidth: 576,
    margin: 0,
    padding: 24,
    boxSizing: 'border-box',
    backgroundColor: color.background,
    border: `1px solid ${color.border}`,
    borderRadius: 0,
    boxShadow: shadowLg,
    color: color.foreground,
    fontFamily,
    fontSize: 16,
    lineHeight: 1.5,
    [smUp]: { borderRadius: 8 }
  },
  header: {
    // AlertDialogHeader: flex-col items-center text-center gap-3 + space-y-2 (12px + 8px)
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    '& > * + *': { marginTop: 20 }
  },
  iconCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 56,
    height: 56,
    borderRadius: '50%',
    flexShrink: 0
  },
  warning: { backgroundColor: color.warning15, color: color.warning },
  primary: { backgroundColor: color.primary10, color: color.primary },
  destructive: { backgroundColor: color.destructive15, color: color.destructive },
  title: {
    margin: 0,
    fontSize: 20,
    lineHeight: '28px',
    fontWeight: 600,
    color: color.foreground
  },
  description: {
    margin: 0,
    fontSize: 14,
    lineHeight: '20px',
    color: color.mutedForeground,
    textAlign: 'center'
  },
  summary: {
    padding: '12px 16px',
    border: `1px solid ${color.border}`,
    borderRadius: 8,
    backgroundColor: color.muted40
  },
  strong: { fontWeight: 600, color: color.foreground },
  medium: { fontWeight: 500, color: color.foreground },
  mutedCenter: {
    margin: 0,
    fontSize: 14,
    lineHeight: '20px',
    color: color.mutedForeground,
    textAlign: 'center'
  },
  error: {
    margin: 0,
    fontSize: 14,
    lineHeight: '20px',
    color: color.destructive
  },
  link: {
    color: color.primary,
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 500,
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' }
  },
  footer: {
    // AlertDialogFooter: flex-row items-stretch gap-2 (+ sm:space-x-2), each button flex-1
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: 8,
    '& > *': { flex: '1 1 0%' },
    [smUp]: {
      justifyContent: 'flex-end',
      '& > * + *': { marginLeft: 8 }
    }
  },
  extras: {
    // Our additions that the mock does not have live here, below the footer, so the footer stays identical.
    display: 'flex',
    justifyContent: 'center',
    marginTop: -8
  }
})

export const useButtonStyles = makeStyles({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    height: 40,
    margin: 0,
    padding: '8px 16px',
    boxSizing: 'border-box',
    border: '1px solid transparent',
    borderRadius: 6,
    fontFamily,
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    outline: 'none',
    transition: 'color 150ms, background-color 150ms, border-color 150ms',
    '&:focus-visible': { boxShadow: focusRing },
    '&:disabled': { opacity: 0.5, pointerEvents: 'none' },
    '& svg': { width: 16, height: 16, flexShrink: 0, pointerEvents: 'none' }
  },
  primary: {
    backgroundColor: color.primary,
    color: color.white,
    '&:hover': { backgroundColor: color.primary90 }
  },
  outline: {
    backgroundColor: color.background,
    borderColor: color.border,
    color: color.foreground,
    '&:hover': { backgroundColor: color.accent }
  },
  ghost: {
    backgroundColor: 'transparent',
    color: color.mutedForeground,
    '&:hover': { backgroundColor: color.accent, color: color.foreground }
  },
  text: {
    height: 'auto',
    padding: '4px 8px',
    fontSize: 12,
    lineHeight: '16px',
    backgroundColor: 'transparent',
    color: color.mutedForeground,
    '&:hover': { color: color.foreground, textDecoration: 'underline' }
  },
  textPrimary: {
    height: 32,
    padding: '6px 12px',
    backgroundColor: 'transparent',
    color: color.primary,
    '&:hover': { backgroundColor: color.primary10 }
  }
})
